<template>
<div>
    <!-- Using hide-overlay below allows for clicking while progress showing-->
    <v-dialog v-model="dialog" persistent :width="options.width" v-bind:style="{ zIndex: options.zIndex }">
        <v-card :color="options.color" dark>
            <v-card-text class="white--text text-center font-weight-black">
                {{ message }}
              
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>
<script>

  export default {
    props: {
      mensajes: {
      type: Array,
      default: []
    },
  },
    data: () => ({ 
      counter: 0,
      fab: false,
      dialog: false,
      message: null,
      options: {
        color: 'primary',
        width: 400,
        zIndex: 200
      },
    
    }),
 
    methods: {
      /**
       * Show loader without any callbacks or timeout (must be manually hidden)
       * @param {string} message
       * @param {object} options
       */
      show(message, options) {
        this.dialog = true
        this.message = message
        this.options = Object.assign(this.options, options);
        this.counter = 0;
        this.changeText();
     
      },
      /**
       * Hide loader (and show snackbar if enabled)
       */
      hide(){
        this.dialog = false
       
      },

   
      changeText() {
        let self = this;
     
          setTimeout(() => {
            
            self.message = self.mensajes[ self.counter ];
            self.counter += 1;
            if(self.counter == self.mensajes.length)
                self.counter = 0;
           
            if(this.dialog)
              self.changeText();
          }, 7000);
      },
    }
  }
</script>
